import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../constants/enums";
import {
  APP_FILE_ACCOUNTING_BANK_ACCOUNT,
  APP_FILE_ACCOUNTING_BANK_ACCOUNT_LIST,
  APP_FILE_ACCOUNTING_BILL,
  APP_FILE_ACCOUNTING_BILL_LIST,
  APP_FILE_ACCOUNTING_BILL_PAYMENT_PAYABLE,
  APP_FILE_ACCOUNTING_BILL_PAYMENT_PAYABLE_LIST,
  APP_FILE_ACCOUNTING_BILL_TRANSACTION_TYPES_LIST,
  APP_FILE_ACCOUNTING_CHEQUE,
  APP_FILE_ACCOUNTING_CHEQUE_LIST,
  APP_FILE_ACCOUNTING_COMPANY,
  APP_FILE_ACCOUNTING_COMPANY_DETAIL,
  APP_FILE_ACCOUNTING_COMPANY_ONBOARDING,
  APP_FILE_ACCOUNTING_CREDIT_CARD_LIST,
  APP_FILE_ACCOUNTING_DASHBOARD,
  APP_FILE_ACCOUNTING_INVOICE_INFORMATION,
  APP_FILE_ACCOUNTING_INVOICE_INFORMATION_LIST,
  APP_FILE_ACCOUNTING_INVOICE_TRANSACTION_LIST,
  APP_FILE_ACCOUNTING_PAYMENT_LIST,
  APP_FILE_ACCOUNTING_TAX_INFO,
  APP_FILE_ACCOUNTING_TRANSACTION_DESCRIPTION_LIST,
  APP_FILE_ACCOUNTING_TRANSACTION_TYPES_LIST,
  APP_FILE_ACCOUNTING_VENDOR,
  APP_FILE_ACCOUNTING_VENDOR_LIST,
  APP_FILE_AGED_INSURER_PAYABLE,
  APP_FILE_BILL_PAYMENT_PAYABLE_BULK_CREATE,
  APP_FILE_BILL_TEMPLATE,
  APP_FILE_BILL_TRANSACTION_TYPE,
  APP_FILE_BULK_BILLS,
  APP_FILE_BULK_INVOICES,
  APP_FILE_CHART_OF_ACCOUNT,
  APP_FILE_CHART_OF_ACCOUNT_LIST,
  APP_FILE_CUSTOMER_STATEMENT,
  APP_FILE_GENERAL_LEDGER_LIST,
  APP_FILE_GL_ACCOUNT_TAB,
  APP_FILE_GL_DETAIL,
  APP_FILE_GL_SUMMARY,
  APP_FILE_INSURANCE_REMITTANCE,
  APP_FILE_INVOICE_BULK_PAYMENT_WRAPPER,
  APP_FILE_INVOICE_PAYMENT_HISTORY_WRAPPER,
  APP_FILE_INVOICE_PAYMENT_WRAPPER,
  APP_FILE_INVOICE_TEMPLATE,
  APP_FILE_INVOICE_TRANSACTION_DESCRIPTION,
  APP_FILE_INVOICE_TRANSACTION_TYPE,
  APP_FILE_PAYMENT_VIEW,
  APP_FILE_SALES_COMMISSION_TAB,
  APP_FILE_TAX_LIST,
  APP_FILE_RECURRING_INVOICES_LIST,
  APP_FILE_CREATE_RECURRING_INVOICE,
} from "./Acoounting.constants";

const AccountingDashboard = Loadable(
  lazy(() =>
    import("./AccountingDashboard/AccountingDashboard").then(
      ({ AccountingDashboard }) => ({
        default: AccountingDashboard,
      })
    )
  )
);
const AccountingInvoiceInformationList = Loadable(
  lazy(() =>
    import("./InvoiceInformation/InvoiceInformationList").then(
      ({ AccountingInvoiceInformationList }) => ({
        default: AccountingInvoiceInformationList,
      })
    )
  )
);
const InvoiceTransactionListWrapper = Loadable(
  lazy(() =>
    import("./InvoiceInformation/InvoiceTransactionListWrapper").then(
      ({ InvoiceTransactionListWrapper }) => ({
        default: InvoiceTransactionListWrapper,
      })
    )
  )
);
const AccountingInvoiceInformation = Loadable(
  lazy(() =>
    import("./InvoiceInformation/InvoiceInformationWrapper").then(
      ({ InvoiceInformationWrapper }) => ({
        default: InvoiceInformationWrapper,
      })
    )
  )
);
const InvoicePaymentHistoryWrapper = Loadable(
  lazy(() =>
    import("./InvoiceInformation/InvoiceHistoryWrapper").then(
      ({ InvoiceHistoryWrapper: InvoicePaymentHistoryWrapper }) => ({
        default: InvoicePaymentHistoryWrapper,
      })
    )
  )
);

const AccountingPaymentList = Loadable(
  lazy(() =>
    import("./Payment/Payment/PaymentListWrapper").then(
      ({ PaymentListWrapper }) => ({
        default: PaymentListWrapper,
      })
    )
  )
);

const AccountingCompany = Loadable(
  lazy(() =>
    import("./Company/CompanyInformation/CompanyInformation").then(
      ({ CompanyInformation }) => ({
        default: CompanyInformation,
      })
    )
  )
);
const AccountingCompanyDetail = Loadable(
  lazy(() =>
    import("./CompanyDetail/CompanyDetail").then(({ CompanyDetail }) => ({
      default: CompanyDetail,
    }))
  )
);

const AccountingCompanyOnboarding = Loadable(
  lazy(() =>
    import("./CompanyOnboarding/CompanyOnboarding").then(
      ({ CompanyOnboarding }) => ({
        default: CompanyOnboarding,
      })
    )
  )
);
const AccountingBillList = Loadable(
  lazy(() =>
    import("./Bill/BillList").then(({ AccountingBillList }) => ({
      default: AccountingBillList,
    }))
  )
);

const AccountingBill = Loadable(
  lazy(() =>
    import("./Bill/Bill").then(({ AccountingBill }) => ({
      default: AccountingBill,
    }))
  )
);
const ChartOfAccount = Loadable(
  lazy(() =>
    import("./ChartOfAccount/ChartsOfAccount").then(({ ChartOfAccount }) => ({
      default: ChartOfAccount,
    }))
  )
);

const ChartOfAccountList = Loadable(
  lazy(() =>
    import("./ChartOfAccount/ChartsOfAccountList").then(
      ({ ChartsOfAccountList }) => ({
        default: ChartsOfAccountList,
      })
    )
  )
);
const AccountingBankAccount = Loadable(
  lazy(() =>
    import("./BankAccount/BankAccount").then(({ AccountingBankAccount }) => ({
      default: AccountingBankAccount,
    }))
  )
);

const AccountingBankAccountList = Loadable(
  lazy(() =>
    import("./BankAccount/BankAccountList").then(
      ({ AccountingBankAccountList }) => ({
        default: AccountingBankAccountList,
      })
    )
  )
);
const AccountingCreditCardList = Loadable(
  lazy(() =>
    import("./CrediCards/CreditCardList").then(({ CreditCardList }) => ({
      default: CreditCardList,
    }))
  )
);
const AccountingChequeList = Loadable(
  lazy(() =>
    import("./Cheque/ChequeList").then(({ AccountingChequeList }) => ({
      default: AccountingChequeList,
    }))
  )
);
const PolicyDefaultCommissionList = Loadable(
  lazy(() =>
    import("./PhysicalDefaultCommission/PhysicalDefaultCommissionList").then(({ PolicyDefaultCommissionList }) => ({
      default: PolicyDefaultCommissionList,
    }))
  )
);

const AccountingCheque = Loadable(
  lazy(() =>
    import("./Cheque/Cheque").then(({ AccountingCheque }) => ({
      default: AccountingCheque,
    }))
  )
);
const GeneralLedgerList = Loadable(
  lazy(() =>
    import("./GeneralLedger/GeneralLedger").then(({ GeneralLedgerList }) => ({
      default: GeneralLedgerList,
    }))
  )
);
const GLSummary = Loadable(
  lazy(() =>
    import("./GLSummary/GLSummary").then(({ GLSummary }) => ({
      default: GLSummary,
    }))
  )
);
const GlDetails = Loadable(
  lazy(() =>
    import("./GLDetails/GLDetails").then(({ GlDetails }) => ({
      default: GlDetails,
    }))
  )
);

const CustomerStatementWrapper = Loadable(
  lazy(() =>
    import("./CustomerStatement/CustomerStatementWrapper").then(
      ({ CustomerStatementWrapper }) => ({
        default: CustomerStatementWrapper,
      })
    )
  )
);
const SalesCommissionTab = Loadable(
  lazy(() =>
    import("./CalBillAgencyorDirect/SalesCommissionTab").then(
      ({ SalesCommissionTab }) => ({
        default: SalesCommissionTab,
      })
    )
  )
);
const InsuranceRemittance = Loadable(
  lazy(() =>
    import("./InsuranceRemittance/InsuranceRemittance").then(
      ({ InsuranceRemittance }) => ({
        default: InsuranceRemittance,
      })
    )
  )
);
const AgedInsurerPayable = Loadable(
  lazy(() =>
    import("./InsuranceRemittance/AgedInsurerPayable").then(
      ({ AgedInsurerPayable }) => ({
        default: AgedInsurerPayable,
      })
    )
  )
);
const TaxList = Loadable(
  lazy(() =>
    import("./Tax/TaxList").then(({ AccountingTaxList }) => ({
      default: AccountingTaxList,
    }))
  )
);
const AccountingTaxInfo = Loadable(
  lazy(() =>
    import("./TaxInfo/TaxInfo").then(({ AccountingTaxInfo }) => ({
      default: AccountingTaxInfo,
    }))
  )
);
const GLAccountTab = Loadable(
  lazy(() =>
    import("./Company/GLAccounts/GLAccounts").then(({ GLAccounts }) => ({
      default: GLAccounts,
    }))
  )
);
const InvoiceTemplate = Loadable(
  lazy(() =>
    import("./InvoiceInformation/Template/Template").then(
      ({ InvoiceTemplate }) => ({
        default: InvoiceTemplate,
      })
    )
  )
);
const InvoicePaymentWrapper = Loadable(
  lazy(() =>
    import("./Payment/Payment/InvoicePaymentWrapper").then(
      ({ InvoicePaymentWrapper }) => ({
        default: InvoicePaymentWrapper,
      })
    )
  )
);
const InvoiceBulkPaymentWrapper = Loadable(
  lazy(() =>
    import("./Payment/Payment/InvoiceBulkPaymentWrapper").then(
      ({ InvoiceBulkPaymentWrapper }) => ({
        default: InvoiceBulkPaymentWrapper,
      })
    )
  )
);
const BulkInvoices = Loadable(
  lazy(() =>
    import("./InvoiceInformation/BulkInvoices/BulkInvoices").then(
      ({ BulkInvoices }) => ({
        default: BulkInvoices,
      })
    )
  )
);

const BulkBills = Loadable(
  lazy(() =>
    import("./Bill/BulkBills/BulkBills").then(({ BulkBills }) => ({
      default: BulkBills,
    }))
  )
);


const PaymentView = Loadable(
  lazy(() =>
    import("./Payment/Payment/PaymentView").then(({ PaymentView }) => ({
      default: PaymentView,
    }))
  )
);
const InvoiceTransactionType = Loadable(
  lazy(() =>
    import("./InvoiceInformation/TransactionTypes/TransactionTypes").then(
      ({ TransactionsType }) => ({
        default: TransactionsType,
      })
    )
  )
);

const InvoiceTransactionDescription = Loadable(
  lazy(() =>
    import(
      "./InvoiceInformation/TransactionDescription/TransactionDescription"
    ).then(({ TransactionDescription }) => ({
      default: TransactionDescription,
    }))
  )
);

const AccountingTransactionTypesList = Loadable(
  lazy(() =>
    import("./InvoiceInformation/TransactionTypes/TransactionTypesList").then(
      ({ TransactionTypesList }) => ({
        default: TransactionTypesList,
      })
    )
  )
);

const AccountingTransactionDescriptionList = Loadable(
  lazy(() =>
    import(
      "./InvoiceInformation/TransactionDescription/TransactionDescriptionList"
    ).then(({ TransactionDescriptionList }) => ({
      default: TransactionDescriptionList,
    }))
  )
);
const AccountingBillPaymentPayableList = Loadable(
  lazy(() =>
    import("./Bill/PaymentPayable/PaymentPayableList").then(
      ({ AccountingBillPaymentPayableList }) => ({
        default: AccountingBillPaymentPayableList,
      })
    )
  )
);

const AccountingBillPaymentPayable = Loadable(
  lazy(() =>
    import("./Bill/PaymentPayable/PaymentPayable").then(
      ({ AccountingBillPaymentPayable }) => ({
        default: AccountingBillPaymentPayable,
      })
    )
  )
);
const BillPaymentPayableView = Loadable(
  lazy(() =>
    import("./Bill/PaymentPayable/BillPaymentPayable").then(
      ({ BillPaymentPayableView }) => ({
        default: BillPaymentPayableView,
      })
    )
  )
);
const BillTemplate = Loadable(
  lazy(() =>
    import("./Bill/Template/template").then(({ BillTemplate }) => ({
      default: BillTemplate,
    }))
  )
);
const AccountingVendor = Loadable(
  lazy(() =>
    import("./Vendor/Vendor").then(({ Vendor }) => ({
      default: Vendor,
    }))
  )
);

const AccountingVendorList = Loadable(
  lazy(() =>
    import("./Vendor/VendorList").then(({ AccountingVendorList }) => ({
      default: AccountingVendorList,
    }))
  )
);

const BillTransactionTypes = Loadable(
  lazy(() =>
    import("./Bill/BillTransactionTypes/BillTransactionTypes").then(
      ({ BillTransactionTypes }) => ({
        default: BillTransactionTypes,
      })
    )
  )
);

const BillTransactionTypesList = Loadable(
  lazy(() =>
    import("./Bill/BillTransactionTypes/BillTransactionTypesList").then(
      ({ BillTransactionTypesList }) => ({
        default: BillTransactionTypesList,
      })
    )
  )
);

const OperatingStatementsList = Loadable(
  lazy(() =>
    import("./OperatingStatements/OperatingStatementsList").then(
      ({ OperatingStatementsList }) => ({
        default: OperatingStatementsList,
      })
    )
  )
);

const BankDebitCredit = Loadable(
  lazy(() =>
    import("./BankDebitCredit/BankDebitCredit").then(
      ({ BankDebitCredit }) => ({
        default: BankDebitCredit,
      })
    )
  )
);


const BalanceSheetStatementsList = Loadable(
  lazy(() =>
    import("./BalanceSheetStatement/BalanceSheetStatementList").then(
      ({ BalanceSheetStatementsList }) => ({
        default: BalanceSheetStatementsList,
      })
    )
  )
);
const TrialBalanceList = Loadable(
  lazy(() =>
    import("./TrialBalance/TrialBalanceList").then(({ TrialBalanceList }) => ({
      default: TrialBalanceList,
    }))
  )
);
const SeedCustomerReceivableBalances = Loadable(
  lazy(() =>
    import("./SeedCustomerReceivableBalances/SeedCustomerReceivableBalances").then(({ SeedCustomerReceivableBalances }) => ({
      default: SeedCustomerReceivableBalances,
    }))
  )
);

const SmallBalanceWaiverTabs = Loadable(
  lazy(() =>
    import("./SeedCustomerReceivableBalances/SmallBalanceWaiverTabs").then(({ SmallBalanceWaiverTabs }) => ({
      default: SmallBalanceWaiverTabs,
    }))
  )
);

const JeEntryList = Loadable(
  lazy(() =>
    import("./JeTypeAndEntry/JeEntry/JeEntryList").then(({ JeEntryList }) => ({
      default: JeEntryList,
    }))
  )
);
const JeType = Loadable(
  lazy(() =>
    import("./JeTypeAndEntry/JeType/JeType").then(({ JeType }) => ({
      default: JeType,
    }))
  )
);

const FiscalPeriodsList = Loadable(
  lazy(() =>
    import("./FiscalPeriods/FiscalPeriodsList").then(
      ({ FiscalPeriodsList }) => ({
        default: FiscalPeriodsList,
      })
    )
  )
);

const FiscalPeriods = Loadable(
  lazy(() =>
    import("./FiscalPeriods/FiscalPeriods").then(
      ({ FiscalPeriods }) => ({
        default: FiscalPeriods,
      })
    )
  )
);

const AccountingTasks = Loadable(
  lazy(() =>
    import("./AccountingTasks/AccountingTasks").then(
      ({ AccountingTasks }) => ({
        default: AccountingTasks,
      })
    )
  )
);


const BulkBillPaymentPayableWrapper = Loadable(
  lazy(() =>
    import("./Bill/PaymentPayable/BulkBillPaymentPayableWrapper").then(
      ({ BulkBillPaymentPayableWrapper }) => ({
        default: BulkBillPaymentPayableWrapper,
      })
    )
  )
);

const JeTypeList = Loadable(
  lazy(() =>
    import("./JeTypeAndEntry/JeType/JeTypeList").then(({ JeTypeList }) => ({
      default: JeTypeList,
    }))
  )
);

const ImportBulkBillPaymentList = Loadable(
  lazy(() =>
    import("./Payment/Payment/ImportBulkPaymentList").then(({ ImportBulkPaymentList }) => ({
      default: ImportBulkPaymentList,
    }))
  )
);

const ImportBulkBillPayment = Loadable(
  lazy(() =>
    import("../importInvoicePayments/importBulkBillPayment").then(({ ImportBulkBillPayment }) => ({
      default: ImportBulkBillPayment,
    }))
  )
);

const RecurringInvoicesList = Loadable(
  lazy(() =>
    import("./RecurringInvoices/RecurringInvoicesList").then(
      ({ RecurringInvoicesList }) => ({
        default: RecurringInvoicesList,
      })
    )
  )
);

const RecurringInvoiceForm = Loadable(
  lazy(() =>
    import("./RecurringInvoices/RecurringInvoiceForm").then(
      ({ RecurringInvoiceForm }) => ({
        default: RecurringInvoiceForm,
      })
    )
  )
);

export const AccountingRoutes = [
  {
    path: `${APP_FILE_ACCOUNTING_DASHBOARD}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[]} allowFullAccess>
        <AccountingDashboard />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ACCOUNTING_INVOICE_INFORMATION_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_INVOICES_LIST]}>
        <AccountingInvoiceInformationList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ACCOUNTING_INVOICE_TRANSACTION_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_INVOICES_TRANSACTIONS]}>
        <InvoiceTransactionListWrapper />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ACCOUNTING_INVOICE_INFORMATION}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_INVOICES_LIST]}>
        <AccountingInvoiceInformation />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ACCOUNTING_INVOICE_INFORMATION}/:invoiceId`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_INVOICES_LIST]}>
        <AccountingInvoiceInformation />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_INVOICE_PAYMENT_HISTORY_WRAPPER}/:invoiceId`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_INVOICE_PAYMENT]}>
        <InvoicePaymentHistoryWrapper />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ACCOUNTING_PAYMENT_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_INVOICE_PAYMENT]}>
        <AccountingPaymentList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ACCOUNTING_COMPANY}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
        <AccountingCompany />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ACCOUNTING_COMPANY}/:companyId`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
        <AccountingCompany />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ACCOUNTING_COMPANY_DETAIL}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
        <AccountingCompanyDetail />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ACCOUNTING_COMPANY_ONBOARDING}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
        <AccountingCompanyOnboarding />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ACCOUNTING_COMPANY_ONBOARDING}/:companyId`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
        <AccountingCompanyOnboarding />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ACCOUNTING_BILL_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_BILLS_LIST]}>
        <AccountingBillList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ACCOUNTING_BILL}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_BILLS_LIST]}>
        <AccountingBill />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ACCOUNTING_BILL}/:billId`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_BILLS_LIST]}>
        <AccountingBill />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_CHART_OF_ACCOUNT_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_CHARTS_OF_ACCOUNTS]}>
        <ChartOfAccountList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_CHART_OF_ACCOUNT}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_CHARTS_OF_ACCOUNTS]}>
        <ChartOfAccount />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_CHART_OF_ACCOUNT}/:companyChartsOfAccCode`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_CHARTS_OF_ACCOUNTS]}>
        <ChartOfAccount />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_CHART_OF_ACCOUNT}/duplicate/:companyChartsOfAccCode`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_CHARTS_OF_ACCOUNTS]}>
        <ChartOfAccount isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ACCOUNTING_BANK_ACCOUNT_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ROLE, MODULE_IDS.ROLE_MODULE]}>
        <AccountingBankAccountList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ACCOUNTING_CREDIT_CARD_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ROLE, MODULE_IDS.ROLE_MODULE]}>
        <AccountingCreditCardList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ACCOUNTING_BANK_ACCOUNT}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
        <AccountingBankAccount />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ACCOUNTING_BANK_ACCOUNT}/:banAccCode`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
        <AccountingBankAccount />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ACCOUNTING_CHEQUE_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_BILL_CHEQUES]}>
        <AccountingChequeList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ACCOUNTING_CHEQUE}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_BILL_CHEQUES]}>
        <AccountingCheque />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ACCOUNTING_CHEQUE}/:chequeId`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_BILL_CHEQUES]}>
        <AccountingCheque />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_GENERAL_LEDGER_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.REPORTS_GENERAL_LEDGER]}>
        <GeneralLedgerList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_GL_SUMMARY}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.REPORTS_GENERAL_LEDGER]}>
        <GLSummary />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_GL_DETAIL}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.REPORTS_GENERAL_LEDGER]}>
        <GlDetails />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_CUSTOMER_STATEMENT}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.REPORTS_CUSTOMER_STATEMENT]}>
        <CustomerStatementWrapper />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_SALES_COMMISSION_TAB}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.REPORTS_SALES_AND_COMMISSION]}>
        <SalesCommissionTab />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_INSURANCE_REMITTANCE}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.REPORTS_SALES_AND_COMMISSION]}>
        <InsuranceRemittance />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_AGED_INSURER_PAYABLE}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ROLE, MODULE_IDS.ROLE_MODULE]}>
        <AgedInsurerPayable />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_TAX_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_SETTINGS_TAX_TABLE]}>
        <TaxList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ACCOUNTING_TAX_INFO}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
        <AccountingTaxInfo />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_GL_ACCOUNT_TAB}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_SETTINGS_ACCOUNTS]}>
        <GLAccountTab />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_INVOICE_TEMPLATE}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_SETTINGS_INVOICE_TEMPLATE]}>
        <InvoiceTemplate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_INVOICE_TEMPLATE}/:customerPolicyId`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_SETTINGS_INVOICE_TEMPLATE]}>
        <InvoiceTemplate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_INVOICE_PAYMENT_WRAPPER}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_INVOICE_PAYMENT]}>
        <InvoicePaymentWrapper />
      </AuthorizedRoute>
    ),
  },
   {
    path: `${APP_FILE_INVOICE_PAYMENT_WRAPPER}/:paymentId`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_INVOICE_PAYMENT]}>
        <InvoicePaymentWrapper />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_INVOICE_BULK_PAYMENT_WRAPPER}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_INVOICE_PAYMENT]}>
        <InvoiceBulkPaymentWrapper />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_BULK_INVOICES}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_INVOICE_PAYMENT]}>
        <BulkInvoices />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_BULK_BILLS}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_BILLS_LIST]}>
        <BulkBills />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_PAYMENT_VIEW}/:paymentId`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_INVOICE_PAYMENT]}>
        <PaymentView />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ACCOUNTING_TRANSACTION_TYPES_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_SETTINGS_TRANSACTION_TYPES]}>
        <AccountingTransactionTypesList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_INVOICE_TRANSACTION_TYPE}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
        <InvoiceTransactionType />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_INVOICE_TRANSACTION_TYPE}/:transactionTypeId`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
        <InvoiceTransactionType />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ACCOUNTING_TRANSACTION_DESCRIPTION_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_SETTINGS_TRANSACTION_DESCRIPTION_LIST]}>
        <AccountingTransactionDescriptionList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_INVOICE_TRANSACTION_DESCRIPTION}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
        <InvoiceTransactionDescription />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_INVOICE_TRANSACTION_DESCRIPTION}/:transactionDescriptionId`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
        <InvoiceTransactionDescription />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ACCOUNTING_BILL_PAYMENT_PAYABLE_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_BILL_PAYMENT]}>
        <AccountingBillPaymentPayableList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ACCOUNTING_BILL_PAYMENT_PAYABLE}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
        <AccountingBillPaymentPayable />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ACCOUNTING_BILL_PAYMENT_PAYABLE}/:paymentId`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
        <AccountingBillPaymentPayable />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ACCOUNTING_BILL_PAYMENT_PAYABLE}/view/:paymentId`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
        <BillPaymentPayableView />
      </AuthorizedRoute>
    ),
  },
   {
    path: `${APP_FILE_BILL_PAYMENT_PAYABLE_BULK_CREATE}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
       <BulkBillPaymentPayableWrapper/>
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_BILL_TEMPLATE}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_SETTINGS_BILL_TEMPLATES]}>
        <BillTemplate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_BILL_TEMPLATE}/:customerPolicyId`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_SETTINGS_BILL_TEMPLATES]}>
        <BillTemplate />
      </AuthorizedRoute>
    ),
  },

  // {
  //   path: "/vendor",
  //   exact: true,
  //   children: [
  {
    path: `${APP_FILE_ACCOUNTING_VENDOR_LIST}`,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_VENDORS_LIST]}>
        <AccountingVendorList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ACCOUNTING_VENDOR}`,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_VENDORS_LIST]}>
        <AccountingVendor />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ACCOUNTING_VENDOR}/:vendorCode`,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_VENDORS_LIST]}>
        <AccountingVendor />
      </AuthorizedRoute>
    ),
  },
  //   ],
  // },
  {
    path: `${APP_FILE_ACCOUNTING_BILL_TRANSACTION_TYPES_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_SETTINGS_BILL_TRANSACTION_TYPES]}>
        <BillTransactionTypesList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_BILL_TRANSACTION_TYPE}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
        <BillTransactionTypes />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_BILL_TRANSACTION_TYPE}/:transactionTypeId`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
        <BillTransactionTypes />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/reports/operating-statements`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.REPORTS_OPERATING_STATEMENTS]}>
        <OperatingStatementsList />
      </AuthorizedRoute>
    ),
  },
    {
    path: `/reports/bank-transactions`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.REPORTS_OPERATING_STATEMENTS]}>
         <BankDebitCredit/>
      </AuthorizedRoute>
    ),
  },
  {
    path: `/reports/balance-sheet-statements`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ROLE, MODULE_IDS.ROLE_MODULE]}>
        <BalanceSheetStatementsList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/reports/trial-balance`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ROLE, MODULE_IDS.ROLE_MODULE]}>
        <TrialBalanceList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/je-type-list`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_SETTINGS_JOURNAL_TYPES]}>
        <JeTypeList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/je-type/manage`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
        <JeType />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/je-type/manage/:jeTypeId`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
        <JeType />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/je-entry-list`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_JE_ENTRY_LIST]}>
        <JeEntryList />
      </AuthorizedRoute>
    ),
  },
    {
    path: `/seed-customer-receivable-balances`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_JE_ENTRY_LIST]}>
        <SeedCustomerReceivableBalances />
      </AuthorizedRoute>
    ),
  },
    {
    path: `/small-balance-waiver`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_JE_ENTRY_LIST]}>
         <SmallBalanceWaiverTabs/>
      </AuthorizedRoute>
    ),
  },
    {
    path: `/fiscal-periods`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_SETTINGS_FISCAL_PERIODS]}>
        <FiscalPeriodsList />
      </AuthorizedRoute>
    ),
  },
   {
    path: `/fiscal-periods/:year`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_SETTINGS_FISCAL_PERIODS]}>
     <FiscalPeriods/>
      </AuthorizedRoute>
    ),
  },
   {
    path: `/accounting-tasks`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_TASKS]}>
     <AccountingTasks/>
      </AuthorizedRoute>
    ),
  },
  {
    path: `/policy-default-commission`,
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <PolicyDefaultCommissionList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/import-bill-payment`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_BILL_PAYMENT]}>
        <ImportBulkBillPaymentList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/import-bill-payment/:invoiceCode`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_BILL_PAYMENT]}>
        <ImportBulkBillPayment />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_RECURRING_INVOICES_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_INVOICES_LIST]}>
        <RecurringInvoicesList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_CREATE_RECURRING_INVOICE}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_INVOICES_LIST]}>
        <RecurringInvoiceForm />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_CREATE_RECURRING_INVOICE}/:recurringInvoiceId`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ACCOUNTING_INVOICES_LIST]}>
        <RecurringInvoiceForm />
      </AuthorizedRoute>
    ),
  },
  // {
  //   path: `/je-entry/manage`,
  //   exact: true,
  //   element: (
  //     <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
  //       <JeEntry />
  //     </AuthorizedRoute>
  //   ),
  // },
  // {
  //   path: `/je-entry/manage/:jeEntryId`,
  //   exact: true,
  //   element: (
  //     <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
  //       <JeEntry />
  //     </AuthorizedRoute>
  //   ),
  // },
];
